function moreOptions() {

    var button =  $('._js-more-options-btn');

    $('.more-options__body').hide();

    button.on('click', function(){
        var parent      = $(this).parents('.more-options'),
            body        = parent.find('.more-options__body'),
            collapsed   = $(this).data('default'),
            expanded     = $(this).data('expanded');

        if ( !parent.hasClass('_expanded') ) {
            parent.addClass('_expanded');
            body.stop().slideDown(300);
            $(this).text(expanded);
        } else {
            parent.removeClass('_expanded');
            body.stop().slideUp(300);
            $(this).text(collapsed);
        }
    });

}